import {Injectable} from '@angular/core';
import {Subject} from "rxjs/Subject";

@Injectable()
export class UploadProgressService {

    /**
     * Fired while file uploading is in progress.
     */
    public onProgress$: Subject<number> = new Subject();

    /**
     * Fired when file uploaded started.
     */
    public onStart$ = new Subject();

    /**
     * Fired when file upload completed.
     */
    public onEnd$ = new Subject();
}


// WEBPACK FOOTER //
// /mnt/e/apps/helpdesk/client/src/app/shared/upload-progress.service.ts